import { observer } from 'mobx-react-lite'
import { ShieldCheckIcon, ShieldExclamationIcon } from '@heroicons/react/20/solid'
import { useInjection } from '@core/providers/inversify-react.provider'
import { AdminModeTogglePresenter } from './admin-mode-toggle.presenter'

/**
 * Absent entirely for a session with no admin capability — see
 * `showToggle` on AdminModeTogglePresenter.viewModel. Mounted beside
 * ThemeToggleComponent / LanguageSwitcherComponent in the top bar.
 */
export const AdminModeToggleComponent = observer(() => {
  const presenter: AdminModeTogglePresenter = useInjection(AdminModeTogglePresenter)
  const vm = presenter.viewModel
  if (!vm.showToggle) return null

  const Icon = vm.enabled ? ShieldCheckIcon : ShieldExclamationIcon

  return (
    <button
      type="button"
      onClick={() => {
        void presenter.toggle()
      }}
      className={`flex items-center justify-center size-9 rounded-md hover:bg-shell-surface-muted ${
        vm.enabled ? 'text-shell-accent' : 'text-shell-ink-muted hover:text-shell-accent'
      }`}
      aria-pressed={vm.enabled}
      aria-label={vm.ariaLabel}
      title={vm.label}
    >
      <Icon className="size-5" aria-hidden="true" />
    </button>
  )
})
